<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">收费月份修改</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="收费名称" required prop="name">
                                    <el-input v-model="editForm.name" placeholder="请输入收费名称"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="价格(元/月)" required prop="price">
                                    <el-input type="number" v-model="editForm.price" placeholder="请输入价格"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-form-item label="选择需要收费的月份" required prop="monthsArr">
                                    <el-checkbox-group 
                                        style="width:100%;"
                                        v-model="editForm.monthsArr"
                                        >
                                        <el-checkbox v-for="item in monthsValue" :label="item" :key="item">{{item}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>


            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Edit',
        props:['ItemList'],
        data() {
            return {
                loading: false,
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    name:'',
                    monthsArr:[],
                    price:'',
                    checkinUnfixedMoneyCode:''
                },
                monthsValue:[1,2,3,4,5,6,7,8,9,10,11,12,],
                rules:{
                    name:[
                        { required: true, message: '请输入名称', trigger: 'blur' },
                    ],
                    price:[
                        { required: true, message: '请输入金额', trigger: 'blur' },
                        {
                            pattern: /^([0-9]?)+(\.[0-9][0-9]?)?$/,
                            message: "小数点后最多只能输入两位", trigger: 'blur'
                        }
                    ],
                    monthsArr:[
                        { type: 'array', required: true, message: '请至少选择一个月份', trigger: 'change' }
                    ],
                }

            }
        },

        methods: {

            init(row){
                this.editForm.checkinUnfixedMoneyCode=row.checkinUnfixedMoneyCode;
                this.editForm.name = row.name;
                this.editForm.monthsArr = JSON.parse(row.months);
                this.editForm.price = row.price;
            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            addSubmit(){

                this.loading = true;
                // this.editForm.monthsArr.sort((a,b)=>{
                //     return a>b;
                // });
                
                let min;
                for(var i=0; i<this.editForm.monthsArr.length; i++){
                    for(var j=i; j<this.editForm.monthsArr.length;j++){
                        if(this.editForm.monthsArr[i]>this.editForm.monthsArr[j]){
                        min=this.editForm.monthsArr[j];
                        this.editForm.monthsArr[j]=this.editForm.monthsArr[i];
                        this.editForm.monthsArr[i]=min;
                        }
                    }
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CheckinUnfixedMoney/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            sortNumber(a,b){
                return a < b;
            }

        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1200px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
